import { PageInfo } from '../../services/shared/shared-interface';
import { NotificationState } from './definitions';

export class NotificationFactory
{
	public static build(): NotificationState
	{
		return {

			loading: true,
			pageHeading: 'Notifications',
			tabs: [
				{
					id: '',
					label: 'All',
					pageInfo: this.getPageInfo(),
					data: [{
						id: '',
						isNewIcon: {
							iconPath: '/assets/green_dot.svg',
							altText: 'greenDot'
						},
						notificationIcon: {
							iconPath: '/assets/active.svg',
							altText: 'active'
						},
						notificationTitle: '',
						notificationDescription: '',
						closeIcon: {
							iconPath: '/assets/close.png',
							altText: 'delete'
						},
						dateCreated: '',
						portalUserID: '',
						status: 'read',
						systemNotificationID: '',
						notificationType: '',
						notificationLink: '',
						hasReport: false

					}
					],
					unreadCountData: 0

				},
				{
					id: '',
					label: 'Update',
					pageInfo: this.getPageInfo(),
					unreadCountData: 0,

					data: this.getNotificationContentByType('active')
				},
				{
					id: '',
					label: 'Action',
					pageInfo: this.getPageInfo(),
					unreadCountData: 0,

					data: this.getNotificationContentByType('action')
				},
				{
					id: '',
					label: 'Offer',
					pageInfo: this.getPageInfo(),
					unreadCountData: 0,

					data: this.getNotificationContentByType('offer')
				}
			],
			markAsRead: 'Mark all as read',
			noNotification: 'No New Notification',
			unreadCount: 0,
			clickHere: ''
		};
	}
	public static getPageInfo(): PageInfo
	{
		return {
			pageSize: 7,
			totalCount: 0
		};
	}
	public static getUnCountData()
	{
		return {
			all: 0,
			offer: 0,
			action: 0,
			update: 0
		};

	}
	public static getNotificationContentByType(type: string)
	{
		let iconPathValue = '';
		let altTextValue = '';
		switch (type)
		{
		case 'offer':
			iconPathValue = '/assets/offer.svg';
			altTextValue = 'offer';
			break;
		case 'action':
			iconPathValue = '/assets/action.svg';
			altTextValue = 'action';
			break;
		case 'active':
			iconPathValue = '/assets/active.svg';
			altTextValue = 'active';
			break;
		}
		return [{
			id: '',
			isNewIcon: {
				iconPath: '',
				altText: ''
			},
			notificationIcon: {
				iconPath: iconPathValue,
				altText: altTextValue
			},
			notificationTitle: '',
			notificationDescription: '',
			closeIcon: {
				iconPath: '/assets/close.png',
				altText: 'delete'
			},
			dateCreated: '',
			portalUserID: '',
			status: 'read',
			systemNotificationID: '',
			notificationType: '',
			notificationLink: '',
			hasReport: false
		}
		];

	}
}
